"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = auth;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

require("regenerator-runtime/runtime");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.promise");

var _utils = _interopRequireDefault(require("../utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var toast = _utils.default.toast,
    isFunction = _utils.default.isFunction,
    isObject = _utils.default.isObject; // 是否已经返回

var isRe = false; // 调用native方法次数

var callNativeTimes = 0; // 将native方法与WLSDK方法绑定，优化native方法调用方式

function connectToNative(moduleName, methodName) {
  if (!window.WLSDK[moduleName]) {
    window.WLSDK[moduleName] = {};
  } // 定义WLSDK与native对应的方法


  window.WLSDK[moduleName][methodName] = function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise(function (resolve, reject) {
      var closeTips = config.closeTips; // 获取入参中所有方法，需要处理成native回调的字符串

      var paramsMethod = Object.keys(params).reduce(function (obj, key) {
        var param = params[key];

        if (isFunction(param)) {
          obj[key] = param;
        }

        return obj;
      }, {}); // 定义通用调用成功方法

      var success = function success(resp) {
        if (resp.errorCode.toString() === '0') {
          resolve(resp.content);
        } else {
          if (!closeTips) {
            toast(resp.errorMsg);
          }

          reject(resp);
        }
      }; // 定义通用调用失败方法


      var error = function error(resp) {
        if (!closeTips) {
          toast(resp.errorMsg);
        }

        reject(resp);
      }; // 获取方法对应的native回调字符串


      var methods = _objectSpread({
        success: success,
        error: error
      }, paramsMethod);

      var methodsString = Object.keys(methods).reduce(function (obj, key) {
        callNativeTimes += 1;
        var targetKey = key + callNativeTimes; // 处理所有回调方法，将字返回的字符串处理成对象

        if (!window.WLSDK.CALLBACK[moduleName]) {
          window.WLSDK.CALLBACK[moduleName] = {};
        }

        if (!window.WLSDK.CALLBACK[moduleName][methodName]) {
          window.WLSDK.CALLBACK[moduleName][methodName] = {};
        }

        window.WLSDK.CALLBACK[moduleName][methodName][targetKey] = function (_resp) {
          var resp = JSON.parse(_resp);
          console.log(obj[key], resp);
          methods[key](resp);
        }; // 定义全局回调字符串，用于native方法调用


        obj[key] = "WLSDK.CALLBACK.".concat(moduleName, ".").concat(methodName, ".").concat(targetKey);
        return obj;
      }, {}); // 调用native方法

      window[moduleName][methodName](JSON.stringify(_objectSpread({}, params, methodsString)));
    });
  };
} // 遍历处理native 授权返回对象，将native方法转为WLSDK方法


function handlerModules(modules) {
  Object.keys(modules).forEach(function (moduleName) {
    // 处理数据结构不一致，Android是对象，ios是数组
    var methods = isObject(modules[moduleName]) ? Object.keys(modules[moduleName]) : modules[moduleName];
    methods.forEach(function (methodName) {
      connectToNative(moduleName, methodName);
    });
  });
}

function auth(opts) {
  return new Promise(
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee(resolve, reject) {
      var timer, _opts$apiList, apiList, _opts$config, config, modules, checkContent, checkModules;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 交互相应超过10S 抛出异常
              timer = setTimeout(function () {
                !isRe && reject('访问超时');
                clearTimeout(timer);
              }, 10000);
              _opts$apiList = opts.apiList, apiList = _opts$apiList === void 0 ? [] : _opts$apiList, _opts$config = opts.config, config = _opts$config === void 0 ? {} : _opts$config;
              window.WLSDK = {
                CALLBACK: {}
              }; // 处理native授权方法，将其转化为WLSDK方法

              modules = {
                WLAuth: {
                  config: true,
                  checkApi: true
                }
              };
              handlerModules(modules); // 调用native授权方法

              _context.next = 7;
              return window.WLSDK.WLAuth.config({
                apiList: apiList
              }, config);

            case 7:
              _context.next = 9;
              return window.WLSDK.WLAuth.checkApi({
                apiList: apiList
              }, config);

            case 9:
              checkContent = _context.sent;
              // 处理native授权得到的方法，将其转化为WLSDK方法
              // 处理返回结果不一致，安卓比ios多一层
              checkModules = checkContent.checkResult ? checkContent.checkResult : checkContent;
              handlerModules(checkModules);
              resolve();
              isRe = true;

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}